<template>
  <h1 class="title mb-8">{{ $t('STEPPER.TITLE') }}</h1>
  <div class="stepper-container">
    <div v-for="(step, index) in steps" :key="step" class="step-wrapper">
      <div class="d-flex flex-column align-center">
        <div class="step" :class="getStepClass(step)" @click="setStep(step)">
          {{ step }}
          <img v-if="step < currentStep" alt="check-icon" class="check-icon"
               src="@/assets/icons/file/check.svg"/>
        </div>
        <div v-if="isScreenLarge" class="label" :class="{ 'past-label': step <= currentStep && isScreenLarge }">
          {{ labels[index] }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { RepairFile } from '@/models/RepairFile'

export default {
  name: 'StepperRepair',
  props: {
    currentStep: Number,
    highestStepReached: Number,
    currentRepairFile: {
      type: RepairFile,
      default: null
    }
  },
  data() {
    return {
      steps: [1, 2, 3, 4, 5, 6, 7],
      labels: [
        this.$t('STEPPER.STEP.ONE'),
        this.$t('STEPPER.STEP.TWO'),
        this.$t('STEPPER.STEP.THREE'),
        this.$t('STEPPER.STEP.FOUR'),
        this.$t('STEPPER.STEP.FIVE'),
        this.$t('STEPPER.STEP.SIX'),
        this.$t('STEPPER.STEP.SEVEN')],
      isScreenLarge: false
    }
  },
  mounted() {
    this.checkScreenSize()
  },
  watch: {
    currentStep() {
      if (this.highestStepReached < this.currentStep) {
        this.$emit('change-highest-step', this.currentStep)
      }
      this.$emit('change-step', this.currentStep)
      if (this.currentStep === 1) {
        this.$router.push('/repair-file/' + this.currentRepairFile.boomerang_id)
      }
    }
  },
  methods: {
    checkScreenSize() {
      this.isScreenLarge = window.innerWidth > 700
    },
    setStep(step) {
      if (step > this.highestStepReached) {
        return
      }
      this.$emit('change-step', step)
    },
    getStepClass(step) {
      if (step === this.currentStep) {
        return 'active-step'
      } else if (step < this.currentStep) {
        return 'past-step'
      } else if (step <= this.highestStepReached) {
        return 'visited-step'
      } else {
        return 'future-step'
      }
    }
  },
  created() {
    window.addEventListener('resize', this.checkScreenSize)
  }
}
</script>

<style scoped>
.stepper-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: flex-start;
}

.step-wrapper {
  justify-content: center;
  display: flex;
  flex: 1;
  position: relative;
}

.step {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background 0.3s ease, color 0.3s ease;
  position: relative;
}

.step-wrapper:not(:first-child):not(:last-child)::before {
  content: "";
  flex-grow: 1;
  height: 1px;
  background: #559A1B;
  transition: background 0.3s ease;
  width: 100%;
  position: absolute;
  align-self: flex-start;
  top: 20px;
}

.step-wrapper:first-child::after {
  content: "";
  flex-grow: 1;
  height: 1px;
  background: #559A1B;
  transition: background 0.3s ease;
  width: 50%;
  margin-left: 50%;
  position: absolute;
  align-self: flex-start;
  top: 20px;
}

.step-wrapper:last-child::before {
  content: "";
  flex-grow: 1;
  height: 1px;
  background: #559A1B;
  transition: background 0.3s ease;
  width: 50%;
  margin-right: 50%;
  position: absolute;
  align-self: flex-start;
  top: 20px;
}

.active-step {
  background: #559A1B;
  color: white;
  z-index: 2;
}

.past-step {
  background: white;
  color: transparent;
  z-index: 2;
}

.future-step {
  background: #EFEFEF;
  color: #559A1B;
  border: 1px solid #559A1B;
  z-index: 2;
}

.label {
  color: black;
  font-size: 14px;
  margin-top: 8px;
  text-align: center;
}

.past-label {
  color: #559A1B;
}

.check-icon {
  fill: #559A1B;
  width: 24px;
  height: 24px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.visited-step {
  background: #AADD8B;
  color: white;
  border: 1px solid #AADD8B;
  cursor: pointer;
}

.title {
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
</style>
